import React, { useEffect } from "react";
import { Col, ListGroup, Row, Button } from "react-bootstrap";
import { connect } from "react-redux";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import { useNavigate } from "react-router-dom";
import { timeDifference } from "../../utils/utilities";
import ApiUtils from "../../utils/api_utils";

const VoucherListItem = ({ item, navigate }) => {
  const { reward, is_used, is_expired, evoucher_valid_until, status } = item;
  const { name, thumbnail_img_url, description } = reward;

  const showDate = () => {
    if (is_used || is_expired) return <span>{status}</span>;
    else if (evoucher_valid_until) {
      return `Expired in ${timeDifference(evoucher_valid_until)}`;
    } else {
      return <span>-</span>;
    }
  };

  return (
    <ListGroup.Item
      className={is_used == true || is_expired === true ? "grey-list" : ""}
    >
      <Row>
        <Col xs={3} sm={3} md={3}>
          <img
            src={
              thumbnail_img_url
                ? ApiUtils.validateImgUrl({ url: thumbnail_img_url })
                : Assets.logo
            }
            className="voucher-image"
            alt="myvoucher_image"
          />
        </Col>
        <Col xs={7} sm={7} md={7} className="voucher-detail">
          <div className="voucher-title">{name}</div>
          <div className="voucher-info">
            <div dangerouslySetInnerHTML={{ __html: description }} />
          </div>
          <div className="voucher-expired">{showDate()}</div>
        </Col>
        <Col xs={2} sm={2} md={2} className="btn-voucher">
          <Button
            variant="danger"
            className="btn-voucher-see"
            onClick={() => {
              navigate(`${PageRoutes.myVoucher}/detail/${item.id}`);
            }}
            disabled={is_used}
          >
            See
          </Button>
        </Col>
      </Row>
    </ListGroup.Item>
  );
};

const MyVoucherDashboard = (props) => {
  const { myvouchers, getUnusedVoucher } = props;
  const navigate = useNavigate();

  useEffect(() => {
    getUnusedVoucher({
      param: {
        pagination: true,
      },
    });
  }, []);

  return (
    <div className="myvoucher-point">
      <div className="myvoucher-header">My Voucher</div>
      {myvouchers &&
        myvouchers.results.slice(0, 3).map((item, index) => {
          return (
            <VoucherListItem
              key={`voucher-list-item-${index}`}
              item={item}
              navigate={navigate}
            />
          );
        })}

      {myvouchers && (
        <Row className="myvoucher-button">
          <Button
            variant="outline-danger"
            className="btn-voucher-outline"
            onClick={() => {
              navigate(PageRoutes.myVoucher);
            }}
          >
            See All Reward Redemption
          </Button>
        </Row>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  myvouchers: state.RewardSM.myvoucher,
});

const mapDispatchToProps = (dispatch) => ({
  getUnusedVoucher: dispatch.RewardSM.getUnusedVoucher,
});

export default connect(mapStateToProps, mapDispatchToProps)(MyVoucherDashboard);
